import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SkillCard from "./SkillCard.js"

import javascript from "../assets/skills/javascript.svg"
import linux from "../assets/skills/linux.svg"
import python from "../assets/skills/python.svg"
import windows from "../assets/skills/windows.svg"
import git from "../assets/skills/git.svg"

import ruby from "../assets/skills/ruby.svg"
import cypress from "../assets/skills/cypress.svg"
import appium from "../assets/skills/appium.svg"
import selenium from "../assets/skills/selenium.svg"
import postman from "../assets/skills/postman.svg"
import newman from "../assets/skills/newman.svg"
import k6 from "../assets/skills/k6.svg.png"
import robot from "../assets/skills/robot.png"
import cucumber from "../assets/skills/cucumber.svg"
import scrum from "../assets/skills/scrum.svg"
import kanban from "../assets/skills/kanban.svg"


import hr from "../assets/curve-hr.svg"

export default function Skills() {
    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1
      };

    return (
        <div id="skills" className="mt-4 text-white">
            <h1 className="text-2xl font-bold">Habilidades</h1>
            <p className="font-light text-gray-400">Aqui estão algumas das minhas habilidades</p>

            <div className="mt-4">
                <Slider {...settings}>
                <SkillCard name="windows" experience="12 anos" img={windows} />
                <SkillCard name="linux" experience="7 anos" img={linux} />

                <SkillCard name="python" experience="3 anos" img={python} />
                <SkillCard name="javascript" experience="5 anos" img={javascript} />
                <SkillCard name="ruby" experience="5 anos" img={ruby} />
                <SkillCard name="git" experience="5 anos" img={git} />
                <SkillCard name="cucumber" experience="5 anos" img={cucumber} />
                <SkillCard name="cypress" experience="5 anos" img={cypress} />
                <SkillCard name="selenium" experience="5 anos" img={selenium} />
                <SkillCard name="appium" experience="3 anos" img={appium} />
                <SkillCard name="postman" experience="5 anos" img={postman} />
                <SkillCard name="newman" experience="2 anos" img={newman} />
                <SkillCard name="k6" experience="1 ano" img={k6} />

                <SkillCard name="Robot Framework" experience="2 anos" img={robot} />

                <SkillCard name="scrum" experience="5 anos" img={scrum} />
                <SkillCard name="kanbam" experience="5 anos" img={kanban} />
                
                </Slider>
            </div>
            <img src={hr} className="w-full mt-8 md:h-3" alt="hr" />
        </div>
    )
}